import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-modaal-ajax]';
const PLUGIN_NAME = 'ModaalAjax';

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "modaal-ajax" */ './modaal-ajax'
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});

	$(document).on('product-teasers-loaded', function(){
		$(ELEMENT_SELECTOR).each(function() {
			const element = this;
			System.import(
				/* webpackChunkName: "modaal-ajax" */ './modaal-ajax'
			).then((module) => {
				plugin(PLUGIN_NAME, module.default);
				$(element)[PLUGIN_NAME]();
			});
		});
	});
});



// WEBPACK FOOTER //
// ./client/src/core/components/modaal-ajax/modaal-ajax--split.js